import axios from '../axios'
import {
    TOURNAMENT_LIST_REQUEST, TOURNAMENT_LIST_SUCCESS, TOURNAMENT_LIST_FAIL,
    TOURNAMENT_DETAILS_REQUEST, TOURNAMENT_DETAILS_SUCCESS, TOURNAMENT_DETAILS_FAIL,
    TOURNAMENT_CREATE_REQUEST, TOURNAMENT_CREATE_SUCCESS, TOURNAMENT_CREATE_FAIL,
    TOURNAMENT_UPDATE_REQUEST, TOURNAMENT_UPDATE_SUCCESS, TOURNAMENT_UPDATE_FAIL,
    TOURNAMENT_DELETE_REQUEST, TOURNAMENT_DELETE_SUCCESS, TOURNAMENT_DELETE_FAIL,
    TOURNAMENT_DAY_CREATE_REQUEST, TOURNAMENT_DAY_CREATE_SUCCESS, TOURNAMENT_DAY_CREATE_FAIL,
    TOURNAMENT_DAY_UPDATE_REQUEST, TOURNAMENT_DAY_UPDATE_SUCCESS, TOURNAMENT_DAY_UPDATE_FAIL,
    TOURNAMENT_DAY_DELETE_REQUEST, TOURNAMENT_DAY_DELETE_SUCCESS, TOURNAMENT_DAY_DELETE_FAIL,
    TOURNAMENT_AWARD_CREATE_REQUEST, TOURNAMENT_AWARD_CREATE_SUCCESS, TOURNAMENT_AWARD_CREATE_FAIL,
    TOURNAMENT_AWARD_DELETE_REQUEST, TOURNAMENT_AWARD_DELETE_SUCCESS, TOURNAMENT_AWARD_DELETE_FAIL,
    TOURNAMENT_CONTEST_CREATE_REQUEST, TOURNAMENT_CONTEST_CREATE_SUCCESS, TOURNAMENT_CONTEST_CREATE_FAIL,
    TOURNAMENT_CONTEST_DELETE_REQUEST, TOURNAMENT_CONTEST_DELETE_SUCCESS, TOURNAMENT_CONTEST_DELETE_FAIL,
    TOURNAMENT_REG_LIST_REQUEST, TOURNAMENT_REG_LIST_SUCCESS, TOURNAMENT_REG_LIST_FAIL,
    TOURNAMENT_REG_ADD_REQUEST, TOURNAMENT_REG_ADD_SUCCESS, TOURNAMENT_REG_ADD_FAIL,
    TOURNAMENT_REG_UPDATE_REQUEST, TOURNAMENT_REG_UPDATE_SUCCESS, TOURNAMENT_REG_UPDATE_FAIL,
    TOURNAMENT_REG_DELETE_REQUEST, TOURNAMENT_REG_DELETE_SUCCESS, TOURNAMENT_REG_DELETE_FAIL,
    TOURNAMENT_TEAMS_LIST_REQUEST, TOURNAMENT_TEAMS_LIST_SUCCESS, TOURNAMENT_TEAMS_LIST_FAIL,
    TOURNAMENT_TEAMS_GENERATE_REQUEST, TOURNAMENT_TEAMS_GENERATE_SUCCESS, TOURNAMENT_TEAMS_GENERATE_FAIL,
    TOURNAMENT_TEAMS_CLEAR_REQUEST, TOURNAMENT_TEAMS_CLEAR_SUCCESS, TOURNAMENT_TEAMS_CLEAR_FAIL,
    TOURNAMENT_TEAM_ADD_REQUEST, TOURNAMENT_TEAM_ADD_SUCCESS, TOURNAMENT_TEAM_ADD_FAIL,
    TOURNAMENT_TEAM_MEMBER_ADD_REQUEST, TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS, TOURNAMENT_TEAM_MEMBER_ADD_FAIL,
    TOURNAMENT_TEAM_MEMBER_REMOVE_REQUEST, TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS, TOURNAMENT_TEAM_MEMBER_REMOVE_FAIL,
    TOURNAMENT_AWARD_UPDATE_REQUEST, TOURNAMENT_AWARD_UPDATE_SUCCESS, TOURNAMENT_AWARD_UPDATE_FAIL,
    TOURNAMENT_CONTEST_UPDATE_REQUEST, TOURNAMENT_CONTEST_UPDATE_SUCCESS, TOURNAMENT_CONTEST_UPDATE_FAIL,
    TOURNAMENT_WINNER_UPDATE_REQUEST, TOURNAMENT_WINNER_UPDATE_SUCCESS, TOURNAMENT_WINNER_UPDATE_FAIL,
} from '../constants/tournamentConstants'

const authHeader = (userInfo) => ({
    headers: { Authorization: `Bearer ${userInfo.token}` },
})

const jsonHeader = (userInfo) => ({
    headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
    },
})


export const listTournaments = () => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/tournaments/', authHeader(userInfo))
        dispatch({ type: TOURNAMENT_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const getTournamentDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_DETAILS_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/tournaments/${id}/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_DETAILS_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const createTournament = (tournamentData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post('/api/tournaments/create/', tournamentData, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateTournament = (id, tournamentData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/tournaments/update/${id}/`, tournamentData, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteTournament = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/tournaments/delete/${id}/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const createTournamentDay = (tournamentId, dayData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_DAY_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(
            `/api/tournaments/${tournamentId}/days/create/`,
            dayData,
            jsonHeader(userInfo)
        )
        dispatch({ type: TOURNAMENT_DAY_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_DAY_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateTournamentDay = (dayId, dayData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_DAY_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(
            `/api/tournaments/days/update/${dayId}/`,
            dayData,
            jsonHeader(userInfo)
        )
        dispatch({ type: TOURNAMENT_DAY_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_DAY_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteTournamentDay = (dayId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_DAY_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/tournaments/days/delete/${dayId}/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_DAY_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_DAY_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const createTournamentAward = (tournamentId, awardId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_AWARD_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.post(`/api/tournaments/${tournamentId}/awards/create/`, { award: awardId }, jsonHeader(userInfo))
        dispatch({ type: TOURNAMENT_AWARD_CREATE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_AWARD_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteTournamentAward = (tournamentAwardId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_AWARD_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/tournaments/awards/delete/${tournamentAwardId}/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_AWARD_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_AWARD_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const createTournamentContest = (tournamentId, payload) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_CONTEST_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.post(`/api/tournaments/${tournamentId}/contests/create/`, payload, jsonHeader(userInfo))
        dispatch({ type: TOURNAMENT_CONTEST_CREATE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_CONTEST_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteTournamentContest = (tournamentContestId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_CONTEST_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/tournaments/contests/delete/${tournamentContestId}/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_CONTEST_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_CONTEST_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const listTournamentRegistrations = (tournamentId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_REG_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/tournaments/${tournamentId}/registrations/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_REG_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_REG_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const addTournamentRegistration = (tournamentId, regData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_REG_ADD_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(`/api/tournaments/${tournamentId}/registrations/add/`, regData, jsonHeader(userInfo))
        dispatch({ type: TOURNAMENT_REG_ADD_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_REG_ADD_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateTournamentRegistration = (regId, regData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_REG_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.patch(`/api/tournaments/registrations/${regId}/update/`, regData, jsonHeader(userInfo))
        dispatch({ type: TOURNAMENT_REG_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_REG_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteTournamentRegistration = (regId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_REG_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/tournaments/registrations/${regId}/delete/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_REG_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_REG_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const listTournamentTeams = (tournamentId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_TEAMS_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/tournaments/${tournamentId}/teams/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_TEAMS_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_TEAMS_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const generateTournamentTeams = (tournamentId, count) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_TEAMS_GENERATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(`/api/tournaments/${tournamentId}/teams/generate/`, { count }, jsonHeader(userInfo))
        dispatch({ type: TOURNAMENT_TEAMS_GENERATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_TEAMS_GENERATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const clearTournamentTeams = (tournamentId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_TEAMS_CLEAR_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/tournaments/${tournamentId}/teams/clear/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_TEAMS_CLEAR_SUCCESS })
    } catch (error) {
        dispatch({ type: TOURNAMENT_TEAMS_CLEAR_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const addTournamentTeam = (tournamentId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_TEAM_ADD_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(
            `/api/tournaments/${tournamentId}/teams/add/`,
            {},
            jsonHeader(userInfo)
        )
        dispatch({ type: TOURNAMENT_TEAM_ADD_SUCCESS, payload: data })
        dispatch(listTournamentTeams(tournamentId))
    } catch (error) {
        dispatch({ type: TOURNAMENT_TEAM_ADD_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const addTeamMember = (teamId, userId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_TEAM_MEMBER_ADD_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(`/api/tournaments/teams/${teamId}/members/add/`, { user: userId }, jsonHeader(userInfo))
        dispatch({ type: TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_TEAM_MEMBER_ADD_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const removeTeamMember = (memberId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_TEAM_MEMBER_REMOVE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.delete(`/api/tournaments/teams/members/${memberId}/remove/`, authHeader(userInfo))
        dispatch({ type: TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_TEAM_MEMBER_REMOVE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateTournamentAward = (awardId, winnerId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_AWARD_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.patch(
            `/api/tournaments/awards/${awardId}/update/`,
            { winner: winnerId ?? '' },
            jsonHeader(userInfo)
        )
        dispatch({ type: TOURNAMENT_AWARD_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_AWARD_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateTournamentContest = (contestId, winnerId, resultYards = null) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_CONTEST_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.patch(
            `/api/tournaments/contests/${contestId}/update/`,
            { winner: winnerId ?? '', result_yards: resultYards },
            jsonHeader(userInfo)
        )
        dispatch({ type: TOURNAMENT_CONTEST_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_CONTEST_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateTournamentWinner = (tournamentId, teamId) => async (dispatch, getState) => {
    try {
        dispatch({ type: TOURNAMENT_WINNER_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.patch(
            `/api/tournaments/${tournamentId}/update-winner/`,
            { winner_team: teamId ?? '' },
            jsonHeader(userInfo)
        )
        dispatch({ type: TOURNAMENT_WINNER_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: TOURNAMENT_WINNER_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
